import { UserSlimModel } from '@abb-procure/data';
import type { AdditionalInfo } from '@abb-procure/error-handling';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { ClipboardService } from '../../services/clipboard.service';
import { Button } from '../button/button.component';
import { Card } from '../card/card.component';
import { Displayable, TagList } from '../tag-list/tag-list.component';

@Component({
  selector: 'procure-page-not-visible',
  templateUrl: './page-not-visible.component.html',
  styleUrl: './page-not-visible.component.scss',
  imports: [Button, RouterLink, Card, QuicklinkDirective, TagList],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotVisible {
  readonly redirectUrl = input<string>('/');
  readonly redirectLabel = input<string>('Go to Dashboard');
  readonly errorDetails = input<AdditionalInfo | null>(null);

  protected readonly label = computed(() => {
    const label = this.errorDetails()?.label;

    return label
      ? `You are not authorized to access "${label}".`
      : 'You do not have sufficient permissions to view the requested page.';
  });

  protected readonly users = computed(
    () =>
      this.errorDetails()?.responsibleUsers?.map(
        (user) => new UserSlimModel(user),
      ) ?? [],
  );

  private readonly clipboardService = inject(ClipboardService);

  protected copyEmail(user: string | Displayable): void {
    const { email } = user as UserSlimModel;

    if (!email) {
      return;
    }

    this.clipboardService.copy(email, false, 'Email copied to clipboard.');
  }
}
